/**
 * @title rxpatientprofile.js: Sub-module for Global pages
 * @description This module is used for patient profile
 * @dependency 
 */
define(['membershipHelper','paymentMethods', 'addressBook', 'memberVerification'], function(helper, PaymentMethods, addressBook, memberVerification) {	
	let regexes = {
			POLICY_HOLDER_NAME: /^[a-zA-Z0-9-\s]*$/,
			DOB_FORMAT: /^(0[1-9]|1[012])[\/](0[1-9]|[12][0-9]|3[01])[\/](19|20)\d\d$/,
			RX_NUMBER: /\(?([0-9]{3})\)\s([0-9]{3})\2?([-]?)([0-9]{4})/,
			BIN_NUMBER: /^(?=.*(.)(?!$|.*\1))(?=.*(?!\1))[0-9]{6}$/,
			PCN_NUMBER: /^[a-zA-Z0-9]{0,15}$/, 			
			IS_ZEROS: /^0+$/
	};
	let rxPatientProfile = {
			
		dynamicFormElement: {},
		newTab: undefined,
		
		init : function() {
			PaymentMethods.init();
			addressBook.init();
			memberVerification.init();
			helper.dobPopulate(this.getForm(), 100);
			this.addValidationMethods();
			this.setSelectedValuesForDate();
			this.bindEvents();			
			this.maskInput(this.getForm());
			this.displayAutoRefillDisabled();
			this.displayNotificationMessage();
			this.bindHeaderAndFooterLinksForLeavePageModal();
		},
		
		bindHeaderAndFooterLinksForLeavePageModal: function() {
			let headerAndFooterLinks = $('#header-widget, #leftnav, #crumbs_ul, #footer-widget, #footer-bottom, #header-pharmacy-user-box, .menu')
			.find("a").not('#customer-service-header');
			headerAndFooterLinks.click(function () {
	            var addressValue = $(this).attr("href");
	            if(addressValue != '#' && addressValue != 'javascript:void(0);') {	            	
	            	let existingProfile = $('#existingProfile').val();
	    			if(existingProfile === 'false'){
	            	COSTCO.rxPatientProfile.openLeavePageModal(addressValue);
	    			} else {
	    				window.location.href = DOMPurify.sanitize(secondaryButtonHref);//Sanitize data.
	    			}
	            }
	            	
	            return false;
	        });
		},
		
	    /**
	     * Bind the back url on patient profile page load
	     *
	     */
	    detectBackButton: function detectBackButton() {
	      if (typeof history.pushState === "function") {
	        history.pushState("back", null, null);
	        window.onpopstate = function () {
	          history.pushState('back', null, null);
	            let address = document.referrer;
          		COSTCO.rxPatientProfile.openLeavePageModal(address);
	        };
	      }
	    },
		
		openLeavePageModal: function(secondaryButtonHref) {			
			    COSTCO.dialog.modalStack({
			      title: messages.PATIENTPROFILE_PHARMACY__LEAVE_PAGE_TITLE,			        
			      body: COSTCO.util.tmpl('patient_profile_leave_page_modal_body_tmpl'),
			      primary: messages.PATIENTPROFILE_PHARMACY__MODAL_BUTTON_STAY_ON_PAGE,
			      secondary: messages.PATIENTPROFILE_PHARMACY__MODAL_BUTTON_LEAVE_PAGE,
			      primary_event: function() {
			        COSTCO.dialog.close();
			      },
			      secondary_event: function() {
			    	  window.location.href = DOMPurify.sanitize(secondaryButtonHref);//Sanitize data.
			      },
			    });			
		},
		

		/**
		 * Bind events on various html elements on the Patient Profile page
		 */
		bindEvents: function() {
			$('#medication_list').keypress(function () {
				return ( this.value.length < 500 );
			});
			$('#medication_list').bind('paste',function () {
				return (( this.value.length +window.clipboardData.getData('Text').length) < 500 );
			});
			
			$('input[name^=drugAllergy_]').bind('keyup change', function(){
				COSTCO.rxPatientProfile.getForm().validate().element('input[name=allergiesSelected]');
			});
			
			$('input[name^=medicalCondition_]').bind('keyup change', function(){
				COSTCO.rxPatientProfile.getForm().validate().element('input[name=medicalConditionsSelected]');
			});
			
			$('input[name=medicationList]').bind('keyup', function(){
				COSTCO.rxPatientProfile.getForm().validate().element('input[name=medicationsSelected]');
			});

			$('#navigation-tabs .table-cell').click(function(event) {
				let clickedTab = $(event.target).find('a').length ? $(event.target).find('a').attr('href').substr(1) : $(event.target).attr('href').substr(1);
				COSTCO.rxPatientProfile.validateCurrentTabBeforeOpenClickedTab(clickedTab, event);
			});
			
			$('#navigation-tabs a').click(function(event) {
				event.preventDefault();
			});
			
			$('#PaymentMethodForm input[id=check-button]').unbind().click(function(event){
				$('#addCardClicked').val('true');
			});
		},
		/**
		 * Add validation methods for form validation
		 */
		addValidationMethods: function() {
			// custom validation for date of birth
			$.validator.addMethod('dob', function(value, element, param) {
	      	
	      	let form = COSTCO.rxPatientProfile.getForm();	      	
	        let valid = true;
	        let month;
	        let day;
	        let year;
	        let errField;
	        let idate;
	        let isFuture = false;
	        let dateEntered = false;
	        
	        let isFutureDate = function(idate) {
	          let today = new Date().getTime();
	          idate = idate.split('/');
	          idate = new Date(idate[2], idate[0] - 1, idate[1]).getTime();
	          return (today - idate) < 0 ? true : false;
	        };
	        
	        if (element.name == 'month' || element.name == 'day' || element.name == 'year') {
	          month = form.find('select[name=month]').val();
	          day = form.find('select[name=day]').val();
	          year = form.find('select[name=year]').val();
	          dateEntered = (month != 'Month' & day != 'Day' & year != 'Year');
	          errField = '#dob_error';
	        } else if (element.name == 'monthInsurance' || element.name == 'dayInsurance' || element.name == 'yearInsurance') {
	          month = form.find('select[name=monthInsurance]').val();
	          day = form.find('select[name=dayInsurance]').val();
	          year = form.find('select[name=yearInsurance]').val();
	          dateEntered = (month != 'Month' & day != 'Day' & year != 'Year')
	          errField = '#insurance_dob_error';
	        } 
	        
	        if (month != 'Month' && day != 'Day' && year != 'Year') {
	          idate = month + '/' + day + '/' + year;
	          if (isFutureDate(idate)) {
	          	isFuture = true;
	          }
	        }
	        if (dateEntered && !isFuture) {
	          $(errField).hide();
	          $('.dateOfBirth').removeClass('error select-error');
	          valid = true;
	        } else {
	          $(element).closest('.dateOfBirth').addClass('error select-error');
	          $(errField).show();
	          if (isFuture) {
	            $(errField)[0].innerHTML = messages.ERR_INCORRECT_DATE_OF_BIRTH;
	          } else {
	            $(errField)[0].innerHTML = messages.ERR_REQUIRED_DOB;
	          }
	          valid = false;
	        }
	        return valid;
	      }, '');
      
      $.validator.addMethod('drugAllergies', function (value, element) {
      	
      	let form = COSTCO.rxPatientProfile.getForm();
      	
    		if($("#is_allergies_yes").is(':checked') && $('#drugAllergy_other').val()=="") {
    			return ($('[name^=drugAllergy_]:checked').length > 0);
    		} else {
    				return true; 
    			}
    	}, messages.ERR_REQUIRED_DRUG_ALLERGIES_V2);
    	
    	$.validator.addMethod('medicalConditions', function (value, element) {
    		
    		let form = COSTCO.rxPatientProfile.getForm();
    		
    		if($("#is_medical_conditions_yes").is(':checked') && $('#medicalCondition_other').val()==""){
    			return ($('[name^=medicalCondition_]:checked').length > 0);
    		}
    		else{
    			return true;
    		}
    	}, messages.ERR_REQUIRED_MEDICAL_CONDITIONS_V2);
    	
    	$.validator.addMethod('medications', function (value, element) { 
    		 if($("#is_medication_yes").is(':checked') && $('#medication_list').val()==""){
    			return false;		 }
    		 else{
    			 return true;
    		 }
    	}, messages.ERR_REQUIRED_MEDICATIONS_V2);
			
			$.validator.addMethod('policyHolderRegEx', function( value, element ) {	
				return regexes.POLICY_HOLDER_NAME.test(value);
			}, messages.ERR_INVALID_POLICYHOLDER);
			
			$.validator.addMethod('phone', function( value, element ) {	
				return regexes.RX_NUMBER.test(value);
			}, messages.ERR_INVALID_PHONE_NUMBER);
			
			/** STRY0157080 Require at least ONE alphabet in each of the name fields */
			$.validator.addMethod("firstNameValidation", function( value, element ) {
				return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
			}, messages.ERR_INVALID_FNAME);
			$.validator.addMethod("lastNameValidation", function( value, element ) {
				return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
			}, messages.ERR_INVALID_LNAME);
			$.validator.addMethod("binNumberIsNumeric", function( value, element ) {
				return regexes.BIN_NUMBER.test(value);
			}, messages.INVALID_BIN_NUMBER);
			$.validator.addMethod("pcnNumberIsAlphaNumeric", function( value, element ) {
			if($('#pcnNumber').val()=="" || regexes.PCN_NUMBER.test(value)){
		    	return true;		 
			} else {
				return regexes.PCN_NUMBER.test(value);
			}
			}, messages.INVALID_PCN_NUMBER);
		},
		/**
		 * If form is not valid for current tab(fromTab), prevent going on next tab(toTab)
		 * and stay on current tab
		 *  
 	     * @param  {[fromTab]} from tab name
 	     * @param  {[toTab]} to tab name
 	     * @param  {[event]} event
	     * @return {void}
		 */
	    setActiveTabAndStopProgress: function(fromTab, toTab, event) {
			if (fromTab != toTab) {
				$('a[href*='+fromTab+']').parent().addClass('active');
				$('a[href*='+toTab+']').parent().removeClass('active');
				$('#'+fromTab).addClass('active in');
				$('#'+toTab).removeClass('active in');
		    event.stopPropagation();
			}
		},
		/**
		 * If form is not valid for current tab(fromTab), prevent going on next tab(toTab)
		 * and stay on current tab
		 *  
 	     * @param  {[currentTab]} current tab name
 	     * @param  {[clickedTab]} clicked tab name
		 */
		goToTab: function(currentTab, clickedTab) {
			$('a[href*='+clickedTab+']').removeAttr('tabindex');
			$('a[href*='+clickedTab+']').parent().addClass('active');
			$('a[href*='+currentTab+']').parent().removeClass('active');
			$('#'+clickedTab).addClass('active in');
			$('#'+currentTab).removeClass('active in');
		},
		/**
		 * Validate current tab before going on clicked tab
		 *  
		 * @param  {[clickedTab]} from tab name
		 * @param  {[event]} event
		 * @return {void}
		 */
		validateCurrentTabBeforeOpenClickedTab: function(clickedTab, event) {
		  
		  let element = ($(event.currentTarget.firstElementChild).length > 0) ? event.currentTarget.firstElementChild.hash : event.currentTarget.hash;
		  let currentTab = $('#patient-profile .tab-pane.active.in').attr('id');
		  this.newTab = clickedTab;
		  
		  if(currentTab == clickedTab){
			return;
		  }
		  
		  this.goToTab(currentTab, clickedTab);
		  
		  switch (clickedTab) {
		    	case 'insurance':		    		
		    		if (!COSTCO.rxPatientProfile.validateAccountAndPatientInfo()) {
		    			COSTCO.rxPatientProfile.setActiveTabAndStopProgress('account-and-patient-info', clickedTab, event);
		    		} 
		    		break;
		    		
		    	case 'payment-method':
			  		if (!COSTCO.rxPatientProfile.validateAccountAndPatientInfo()) {
			  			COSTCO.rxPatientProfile.setActiveTabAndStopProgress('account-and-patient-info', clickedTab, event);
		    		} else if (!COSTCO.rxPatientProfile.validateInsurance()) {
			  			COSTCO.rxPatientProfile.setActiveTabAndStopProgress('insurance', clickedTab, event);
		    		}
		    		break;
		    		
		    	case 'address':
		    		if (!COSTCO.rxPatientProfile.validateAccountAndPatientInfo()) {
		    			COSTCO.rxPatientProfile.setActiveTabAndStopProgress('account-and-patient-info', clickedTab, event);
		    		} else if (!COSTCO.rxPatientProfile.validateInsurance()) {
		    			COSTCO.rxPatientProfile.setActiveTabAndStopProgress('insurance', clickedTab, event);
		    		}
					addressBook.bindEvents();
		    		break;
		    		
		    	case 'privacy':
		    		if (!COSTCO.rxPatientProfile.validateAccountAndPatientInfo()) {
		    			COSTCO.rxPatientProfile.setActiveTabAndStopProgress('account-and-patient-info', clickedTab, event);
		    		} else if (!COSTCO.rxPatientProfile.validateInsurance()) {
		    			COSTCO.rxPatientProfile.setActiveTabAndStopProgress('insurance', clickedTab, event);
		    		} else if (!COSTCO.rxPatientProfile.validateAddress()) {
		    			COSTCO.rxPatientProfile.setActiveTabAndStopProgress('address', clickedTab, event);
		    		}
		    		break;
		    		
		    	default:
		    		this.goToTab(currentTab, clickedTab);
		    		break;
			}
		  	
		  	COSTCO.util.notification.clearNotification();
		  	
		},
		/**
		 * get form patient-profile-form
		 */
		getForm: function() {
			return $('#patient-profile-form');
		},
		/**
		 * go on previous tab on click button back
		 */
		back: function() {
			let activeTab = $('#navigation-tabs').find('a[aria-selected="true"]').parent();
			if (activeTab.length) {
				const prevTab = activeTab.prev();
				const prevTabArticle = $(prevTab).find('a')
				if (!prevTabArticle) {
					return;
				}
				const prevTabArticleHref = prevTabArticle.attr("href")
				if (!prevTabArticleHref || !prevTabArticleHref.length) {
					return;
				}
				this.newTab = prevTabArticleHref.substr(1)
			}
			rxPatientProfile.updateA11yAriaSelected()
			$('#navigation-tabs .active').prev('div').trigger('click');
			$('html, body').animate({scrollTop: 200}, 300);
		},
		/**
		 * go on next tab on click button back
		 */
		next: function() {
			
			let activeTab = $('#navigation-tabs .active').find('a').attr("href").substr(1);
						
			switch(activeTab) {
		    	case 'account-and-patient-info':
		    		this.newTab = 'insurance';
		    		if(COSTCO.rxPatientProfile.validateAccountAndPatientInfo()){
		    			COSTCO.rxPatientProfile.goNext();
		    		}
		    		break;
		    	case 'insurance':
		    		this.newTab = 'payment-method';
		    		if(COSTCO.rxPatientProfile.validateInsurance()){
		    			COSTCO.rxPatientProfile.goNext();
		    		}
		    		break;
		    	case 'payment-method':
		    		$('#addCardClicked').val('false');
		    		this.newTab = 'address';
		    		COSTCO.rxPatientProfile.goNext();
		    		addressBook.addjustCells('.resizable');
		    		break;
		    	case 'address':
					this.newTab = 'privacy';
		    		if(COSTCO.rxPatientProfile.validateAddress()){
		    			COSTCO.util.notification.clearNotification();
		    			COSTCO.rxPatientProfile.goNext();
		    		}
					addressBook.bindEvents();
		    		break;
		    	default:
		    		COSTCO.rxPatientProfile.goNext();
		    		break;
			}
			
		},
	    /**
	     * Uses Jquery Mask plugin to format input.
	     * 
	     * @param  {[type]} template [description]
	     * @return {void}          [description]
	     */
	    maskInput: function(template) {
			if($(template).find('[name=insurancePhone]')){
				$(template).find('[name=insurancePhone]').unmask().mask('(000) 000-0000');
			}
	    },
	    /**
	     * Validate AccountAndPatientInfo
	     * 
	     * @param {void}
	     * @return {boolean}
	     */
	    validateAccountAndPatientInfo: function(){
	    	let settings = this.getForm().validate().settings;
	    	settings.rules = {
	    			patientFirstName: {required: true, firstNameValidation: true},
	    			patientLastName: {required: true, lastNameValidation: true},
	    			month: {dob: true},
	    			day: {dob: true},
	    			year: {dob: true},
	    			gender: 'required',
	    			profileType: 'required',
					allergiesSelected: {required: true, drugAllergies: true },
	    			medicalConditionsSelected: {required:true, medicalConditions:true },
	    			medicationsSelected: {required:true, medications:true }
	    	};
	    	settings.messages = {
	    			patientFirstName: {required: messages.ERR_REQUIRED_PT_FIRST_NAME, firstNameValidation: messages.ERR_INVALID_FNAME},
	    			patientLastName: {required: messages.ERR_REQUIRED_PT_LAST_NAME, lastNameValidation: messages.ERR_INVALID_LNAME},
	    			gender: messages.ERR_REQUIRED_PT_GENDER,
	    			profileType: messages.ERR_REQUIRED_PT_PROFILETYPE,
	    			allergiesSelected: {required: messages.ERR_REQUIRED_YES_NO_ANSWER, drugAllergies:messages.ERR_REQUIRED_DRUG_ALLERGIES_V2},
	    			medicalConditionsSelected: {required: messages.ERR_REQUIRED_YES_NO_ANSWER, medicalConditions:messages.ERR_REQUIRED_MEDICAL_CONDITIONS_V2},
	    			medicationsSelected: {required: messages.ERR_REQUIRED_YES_NO_ANSWER, medications:messages.ERR_REQUIRED_MEDICATIONS_V2},
	    			
	    	};
	    	settings.errorPlacement = 
	    		function(error, element){
    				if ( element.is(":radio") ){
    					error.appendTo( element.parents('.error-check') );
    					error.css({'width':'100%'});
    				} else { 
    					error.insertAfter( element );
	    		}
				};

	    	return this.getForm().valid();
	    },
	    	
	    /**
	     * Validate Insurance
	     * 
	     * @param {void}
	     * @return {boolean}
	     */
	    validateInsurance: function(){
	    	let binNumber = $('[name="binNumber"]').val();
			$('[name="binNumber"]').val(this.padZeros(binNumber));
			
	    	let settings = this.getForm().validate().settings;
	    	let radioYesSelected = $('#radioYes').is(':checked');
	    	settings.rules = {
	    			insuranceSelected : {required: true},
	    			insuranceMemberId : {required: radioYesSelected},
	    			groupNumber : {required: radioYesSelected},
	    			policyholderName : {required: radioYesSelected, policyHolderRegEx: radioYesSelected},
	    			binNumber : {required: radioYesSelected, binNumberIsNumeric: radioYesSelected},
					pcnNumber: {pcnNumberIsAlphaNumeric: radioYesSelected},
	    			monthInsurance : {dob: radioYesSelected},
	    			dayInsurance : {dob: radioYesSelected},
	    			yearInsurance : {dob: radioYesSelected},
	    			planName : {required: radioYesSelected},
	    			insurancePhone : {required: radioYesSelected, phone: radioYesSelected}};
	    	
	    	settings.messages ={
	    			insuranceSelected : messages.ERR_REQUIRED_YES_NO_ANSWER,
	    			insuranceMemberId : messages.ERR_REQUIRED_MEMBER_ID,
	    			groupNumber : messages.ERR_REQUIRED_GROUP_NUMBER,
	    			binNumber : { required: messages.INVALID_BIN_NUMBER, binNumberIsNumeric: messages.INVALID_BIN_NUMBER},
					pcnNumber: {pcnNumberIsAlphaNumeric: messages.INVALID_PCN_NUMBER},
	    			policyholderName : { required : messages.ERR_REQUIRED_POLICYHOLDER_NAME,
    										policyHolderRegEx : messages.ERR_INVALID_POLICYHOLDER},
	    			planName : messages.ERR_REQUIRED_PLAN_NAME,
	    			insurancePhone : {required:messages.ERR_REQUIRED_INSURANCE_PHONE, 
    											phone: messages.ERR_INVALID_PHONE_NUMBER}};
	    	
	    	settings.errorPlacement = 
	    		function(error, element){
    				if ( element.is(":radio") ){
    					error.appendTo( element.parents('.insuranceBody') );
    				} else { 
    					error.insertAfter( element );
    				}
				};
			return this.getForm().valid();
	    },
	    /**
	     * Validate Payment method
	     */
	    validatePaymentMethod: function() {
	    	if ($('#PaymentMethodForm').length > 0) {
				TokenGateway.updateSessionFromForm('card', function() {
					COSTCO.PaymentMethods.formSubmitter();
				},'PaymentMethodForm');
				
				return false;
				
	    	} else {
	    		return true;
	    	}    		
	    },
	    
	    /**
	     * Validate address
	     */
	    validateAddress: function() {

	    	let valid = true;
	    	let errors = [];
	    	
	    	if (addressBook.getDefaultAddress(addressBook.ADDRESS_TYPE_SHIPPING).length == 0) {
	    		valid = false;
	    		errors.push(messages.ERR_ADDRESSBOOK_MISSING_SHIPPING_ADDR);
	    	}
	    	//see if address length is longer than 30 characters - stry0130872
	    	else if (addressBook.getDefaultAddress(addressBook.ADDRESS_TYPE_SHIPPING)[0].addressLine0.length > 30 ) {
	    		valid = false;
	    		errors.push(messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE);
	    	}
	    		    	
	    	if (addressBook.getDefaultAddress(addressBook.ADDRESS_TYPE_BILLING).length == 0) {
	    		valid = false;
	    		errors.push(messages.ERR_ADDRESSBOOK_MISSING_BILLING_ADDR);
	    	}
	    	//see if address length is longer than 30 characters - stry0130872
	    	else if (addressBook.getDefaultAddress(addressBook.ADDRESS_TYPE_BILLING)[0].addressLine0.length > 30) {
	    		valid = false;
	    		errors.push(messages.ERR_INVALID_STREETADDRESS_LENGTH_FRIENDLY_MESSAGE);
	    	}

	    	if (!valid && errors.length > 0) {
	    		COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, errors, true);	
	    	}
	    	
	    	return valid;
	    },
	    
	    /**
	     * Validate Privacy
	     */
	    validatePrivacy: function(){
	    	
	    	var settings = this.getForm().validate().settings;
	    	
	    	settings.rules = {privacynoticecheck : {required: true}};
	    	
	    	settings.messages = {privacynoticecheck : messages.ERR_REQUIRED_PRIVACY_ACKNOWLEDGE};
	    	
	    	settings.errorPlacement = 
	    		function(error, element){    			
	    			if ( element.is(":checkbox") ){
	    				error.appendTo( element.parent("div").parent("div"));
	    			} else { 
	    				error.insertAfter( element );
	    			}
    	    	};
	    	return this.getForm().valid();
	    },
	    /**
	     * Preselect values for month day and year for date of birth of policy holder
	     * 
	     * @param {void}
	     * @return {boolean}
	     */
	    setSelectedValuesForDate: function(){
	    	let policyHolderDateOfBirth = $('[name="policyHolderDOB"]').val();
	    	if(policyHolderDateOfBirth){
	    		let policyHolderDateOfBirthArray = policyHolderDateOfBirth.split('/');
	    		
	    		$("#monthInsurance").val(policyHolderDateOfBirthArray[0].replace(/^0+/, ''));
	    		$("#dayInsurance").val(policyHolderDateOfBirthArray[1].replace(/^0+/, ''));
	    		$("#yearInsurance").val(policyHolderDateOfBirthArray[2]);
	    	}
	    	
	    	let patientDateOfBirth = $('[name="patientDOB"]').val();
	    	let isDependentFlag = $('[name="isDependentFlag"]').val();
	    	if(patientDateOfBirth !== null && isDependentFlag === "false"){
	    		let patientDateOfBirthArray = patientDateOfBirth.split('/');
	    		
	    		$("#month").val(patientDateOfBirthArray[0].replace(/^0+/, ''));
	    		$("#day").val(patientDateOfBirthArray[1].replace(/^0+/, ''));
	    		$("#year").val(patientDateOfBirthArray[2]);
	    	}
	    },
	    /**
		 * Set plan name, phone insurance, bin and pcn for selected plan name 
		 * 
		 * @param {void}
		 * @return {boolean}
		 */
	    setPlanAndPhone: function(plans){
	    	let selectedInsurancePlan = $("#insuranceList option:selected");
	    	$("#planName").val(selectedInsurancePlan.val());
	    	$("#insurancePhone").val(selectedInsurancePlan.data('insurance-phone'));
	    	$("#binNumber").val(selectedInsurancePlan.data('binnumber'));
	    	$("#pcnNumber").val(selectedInsurancePlan.data('pcnnumber'));
	    	$("#planName").focusout().change();
	    	$("#insurancePhone").focusout().change();
	    	$("#pcnNumber").focusout().change();
	    	$("#binNumber").focusout().change();
		},
		
	    /**
	     * SaveProfile
	     * 
	     * @param {void}
	     * @return {void}
	     */
	    saveProfile: function(event) {
			let activeTab = $('#navigation-tabs .active').find('a').attr("href").substr(1);
			if (!COSTCO.rxPatientProfile.validateAccountAndPatientInfo()) {
				$('#patient-profile-form').find(":input.error:first").focus();
	  			COSTCO.rxPatientProfile.setActiveTabAndStopProgress('account-and-patient-info', activeTab, event);
	  			return;
	  		}
	  		if (!COSTCO.rxPatientProfile.validateInsurance()) {
	  			let binNumber = $('[name="binNumber"]').val();
				$('[name="binNumber"]').val(this.padZeros(binNumber));
				$('#patient-profile-form').find(":input.error:first").focus();
	  			COSTCO.rxPatientProfile.setActiveTabAndStopProgress('insurance', activeTab, event);
	  			return;
	  		}
	  		if (!COSTCO.rxPatientProfile.validateAddress()) {
	  			COSTCO.rxPatientProfile.setActiveTabAndStopProgress('address', activeTab, event);
	  			return;
	  		}
	  		this.setDateOfBirthHiddenFields();
	  		this.extractFormData('patient-profile-form');
	  		this.getForm().submit();
	    },
	    /**
	     * Complete Profile
	     * 
	     * @param {void}
	     * @return {void}
	     */
	    completeProfile: function() {
	    	if(this.validatePrivacy()){
	    		this.setDateOfBirthHiddenFields();
	    		this.extractFormData('patient-profile-form');
	    		this.getForm().submit();
	    	}
	    },
		 /**
	     * Update A11y aria-selected
	     * 
	     * @param {void}
	     * @return {void}
	     */
		 updateA11yAriaSelected: function() {
			$('#navigation-tabs').find('a').each((index, tab) => {
				if (!tab) {
					return;
				}
				if ($(tab).attr("href").substr(1) !== this.newTab) {
					$(tab).attr('aria-selected', 'false');
				} else {
					$(tab).attr('aria-selected', 'true');
				}
			})
		},
	    /**
	     * Go next
	     * 
	     * @param {void}
	     * @return {void}
	     */
	    goNext: function() {
			rxPatientProfile.updateA11yAriaSelected()
			$('#navigation-tabs .active').next('div').find('a').attr('aria-disabled', 'false');
			$('#navigation-tabs .active').next('div').removeClass('disabled');
			$('#navigation-tabs .active').next('div').trigger('click');
			$('html, body').animate({scrollTop: 200}, 300);
		},
	    /** 
	     * Displays prescription details modal
	     */
	    displayPrescriptionDetails: function () {
			COSTCO.dialog.createExtDialogBox({
				title: messages.PATIENTPROFILE_PHARMACY__PrescriptionDetails_Title,
				body: COSTCO.util.tmpl('patient_profile_prescription_details_modal', {}),
				primary: messages.JS_DIALOG_CLOSE,
				onclose: function() {
					COSTCO.dialog.close();
				},
			});
		},
		/**
		 * Displays Need Help modal
		 */
		displayNeedHelp: function() {
			let activeTab = $('#navigation-tabs .active').find('a').attr("href").split('-')[0].substr(1);
			let dialogBody = $('<div/>').html(COSTCO.util.tmpl('patient_profile_need_help_modal', {}));
			
			if (activeTab !== 'privacy') {
				
				dialogBody.find('#accordion-need-help > div').each(function() {
					
					if (!$(this).attr('id').startsWith(activeTab)) {
						$(this).hide();
					} 
				});
			}
			
			COSTCO.dialog.createExtDialogBox({
				title: messages.RWD_HELP,
				body: dialogBody.html(),
				primary: messages.JS_DIALOG_CLOSE,
				dialogclasses: 'patientProfileModal',
				onshown: function() {
					$('#accordion-need-help [id^=' + activeTab + ']').each(function() {
						$(this).click();
					});
				},
				afterclose: function() {
					$('#need-help-link-button').focus();
				}
			});
		},
		/**
		 * Displays Auto Refill Disabled modal
		 */
		displayAutoRefillDisabled: function() {
			if (autoRefillDisenrolled) {
				COSTCO.dialog.createExtDialogBox({
					title: messages.REFILL_PRESCRIPTION_TITLE_NOREFILL,
					body: COSTCO.util.tmpl('no_refill_patient_profile_modal', {}),
					primary: messages.JS_DIALOG_CLOSE,
				});
			}
		},
		/**
		 * Displays Auto Refill Reminder Checked dialog when user unchecks auto refill reminder
		 * checkbox on Account and Patient Info page
		 */
		displayAutoRefillReminderChecked: function() {
			if($('#autoRefillReminder').is(':unchecked')) {
				COSTCO.dialog.createExtDialogBox({
					title: messages.DISABLE_AUTOREFILL_REMINDER_DIALOG_TITLE,
					body: messages.DISABLE_AUTOREFILL_REMINDER_DIALOG_CONTENT,
					primary: messages.JS_DIALOG_CLOSE,
					onclose: function() {
						COSTCO.dialog.close();
					},
				});
			} else {
				COSTCO.dialog.createExtDialogBox({
					title: messages.PATIENTPROFILE_PHARMACY__PrescriptionDetails_Title,
					body: COSTCO.util.tmpl('patient_profile_prescription_details_modal', {}),
					primary: messages.JS_DIALOG_CLOSE,
					onclose: function() {
						COSTCO.dialog.close();
					},
				});
			}
		},

		/**
		 * Puts the user's focus on the notification for accessibility
		 */
		displayNotificationMessage: function() {
			$('#notification-area').focus();
		},


		/**
		 * Persists user data to session object and forwards user to Change Password page
		 */
		updatePassword: function() {
			this.dynamicFormElement.updatePatientPassword = {
				'userAction' : 'update-password',
			};
			this.persistPatientProfile('updatePatientPassword');
		},
	    /**
	     * Persists user data to session object and forwards user to Account Details page
	     */
		updateEmailOrMembershipNumber: function() {
			this.dynamicFormElement.updateEmailAndMemberId = {
				'userAction' : 'update-email-memberid',
			};
			this.persistPatientProfile('updateEmailAndMemberId');
		},
		/**
		 * Persists user data to session object and forwards user to Edit Payment Method page
		 */
		editPaymentMethod: function() {
			this.dynamicFormElement.editPaymentMethod = {
				'userAction' : 'editPaymentMethod',
			};
			
			this.persistPatientProfile('editPaymentMethod');
		},
		/**
		 * Persists user data to session object
		 * @param  {String} action	Action to perform
		 */
		persistPatientProfile : function(action) {
			
			var self = this;
			self.createDynamicFormElements(action);
			self.extractFormData('PharmacyPersistPatientProfileForm');
			document.forms.PharmacyPersistPatientProfileForm.submit();
			
			/* TODO: Nikola - check if this is ok with Darko and delete/update
				var persist = function () {
				self.createDynamicFormElements(action);
				self.extractFormData('PharmacyPersistPatientProfileForm');
				document.forms.PharmacyPersistPatientProfileForm.submit();
			}
			
			if(isConfirmEnabled) {
				
				ConfirmModal.modal({
					content: "#defaultAddressConfirmationDialog",
					confirmText : messages.JS_DIALOG_ACCEPT,
					dialogOptions : {
						title : messages.JS_CHANGE_DEFAULT_ADDRESS_TITLE
					},								
					onConfirm: persist 
				});
			} else {
					persist();
			}*/
		},
		/**
		 * Adds input elements to Persist Patient Profile form
		 * @param  {String} action	Action to perform
		 */
		createDynamicFormElements : function(action){
			var param = this.dynamicFormElement[action];
			var length = param.length;
			if($('#authToken').length > 0){
			  param['authToken'] = $('#authToken').attr('token');
			}
			for(var key in param){
				$("<input type='hidden'/>").attr({'id':'Patient_Profile_'+key, 'name':key, 'value':param[key]}).appendTo("#PharmacyPersistPatientProfileForm");
			}
		},
		/**
		 * Append data from Address and Payment Method forms to specified form
		 * @param {String} appendTo	Id of form for appending data
		 */
		extractFormData : function(appendTo) {
			
			this.setDateOfBirthHiddenFields();
			$("<input type='hidden'/>").attr({'id': 'Patient_Profile_userData', 'name':'userData', 'value': $('#patient-profile-form').serialize()}).appendTo('#' + appendTo);
		},
		/**
		 * set hidden date of birth input fields for form submit
		 * 
		 * @param {void}
		 * @return {void}
		 */
		setDateOfBirthHiddenFields: function() {
				let month = $("#month").val();
	  		let day = $("#day").val();
	  		let year = $("#year").val();
	   		month = (month && (month.length == 1)) ? ('0' + month) : month;
	   		day = (day && (day.length == 1)) ? ('0' + day) : day;
	   		
	  		$("#patientDOB").val(month + '/' + day + '/' + year);
				
				let radioYesSelected = $('#radioYes').is(':checked');
				if (radioYesSelected) {
		   		let monthInsurance =  $("#monthInsurance").val();
		   		let dayInsurance =  $("#dayInsurance").val();
		   		let yearInsurance =  $("#yearInsurance").val();
		   		
		   		monthInsurance = (monthInsurance && (monthInsurance.length == 1)) ? ('0' + monthInsurance) : monthInsurance;
		   		dayInsurance = (dayInsurance && (dayInsurance.length == 1)) ? ('0' + dayInsurance) : dayInsurance;
		   		$("#policyHolderDOB").val(monthInsurance + '/' + dayInsurance + '/' + yearInsurance);
			}
		},
		/**
		 * Process tokenization response 
		 * 
		 * @param {string} response	response from Accertify web service
		 * @return {void}
		 */
		processTokenizationResponse: function(response) {
			
			if (COSTCO.PaymentMethods.validatePaymentMethodForm()) {
				$('#navigation-tabs .active').next('div').find('a').attr('aria-disabled', 'false');
				$('#navigation-tabs .active').next('div').removeClass('disabled');
				$('a[href*='+this.newTab+']').parent().addClass('active');
				$('a[href*=payment-method]').parent().removeClass('active');
				$('#'+this.newTab).addClass('in active');
				$('#payment-method').removeClass('active');
				
				if(this.newTab === 'address') {
					addressBook.addjustCells('.resizable');
				}
			} 
			
		},
		
		/**
		 * Adds new address. 
		 * If there is no addresses of particular type, 
		 * newly created address will be set as default. 
		 * Otherwise, address won't be set as default.
		 */
		addNewAddress : function() {
			let setAsDefault = addressBook.filterAddressesByType(addressBook.getActiveAddressType()).length == 0;
			addressBook.addNewAddress(setAsDefault);
		},
		
		//Main switch for aria-expand/aria-selected attribute value for all rx tabs
		//TODO: this switch should break into two parts one for Parent Tabs and another switch for child tabs
		// this common switch is having issues when dealing with Accessibility issues for child tabs.
		 rxAriaExpandSwitch: function() {
		      $('.costco-tabs-alternate .table-cell a').unbind('click').on('click', function(e) {
		        let $activeCell = $(this).parent();
		        $activeCell.parents('.costco-tabs-alternate').find('.table-cell').removeClass('active');
		        $activeCell.addClass('active');
		        
		        //Updates aria-expanded attribute true/false
		        if($activeCell.hasClass('active')) {
		        	$('.costco-tabs-alternate .table-cell a').attr('aria-selected', 'false');
		        	//TODO: Need to move into a common method when introducing a brand new child tabs if in-future.
		        	$(e.currentTarget).attr('aria-selected', 'true');
		        	if($('#shippingTab').hasClass('active')){
		        		$('#shippingTab').find('a').attr('aria-selected', 'true');
		        	}else if($('#billingTab').hasClass('active')){
		        		$('#billingTab').find('a').attr('aria-selected', 'true');
		        	}
		        } else {
		        	$('.costco-tabs-alternate .table-cell a').attr('aria-selected', 'true');
		        	$(e.currentTarget).attr('aria-selected', 'false');
		        };
		      });
		 },
		 padZeros: function(num) {
		     if(num) {
		         if (!(regexes.IS_ZEROS.test(num))) {
		             return num.toString().padStart(6, 0);
		         }
		     }
		}
		
	}
	if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
	} 
	
	window.COSTCO.rxPatientProfile = rxPatientProfile;
		
	return rxPatientProfile;
    
});


// WEBPACK FOOTER //
// ./js/rx/rxpatientprofile.js